exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".DynamicDropdown__popper-ref___3GLyI{min-width:100%;z-index:999}\n", ""]);

// Exports
exports.locals = {
	"popper-ref": "DynamicDropdown__popper-ref___3GLyI"
};